import { Modal, Typography, Box, Button } from '@mui/material';
import styles from './styles/ModalTermsConditions.module.scss';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { termsText } from 'shared/assets/terminos-condiciones-firma-electronica';

interface ModalTermsConditionsProps {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
  readOnly?: boolean;
}

export const ModalTermsConditions = ({ open, onClose, onAccept, readOnly = false }: ModalTermsConditionsProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className={styles.modalTerms}
      data-testid='modal-terms-conditions'
    >
      <Box className={styles.container} data-testid='container-box'>
        <section className={styles.header}>
          <Typography className={styles.titleModal}>
            Términos y Condiciones del Acuerdo de Firma Electrónica
          </Typography>
          <IconButton
            className={styles.buttonClose}
            onClick={onClose}
            data-testid='button-close'
          >
            <CloseIcon />
          </IconButton>
        </section>
        <section className={styles.termsContent}>
          <Typography className={styles.termsText}>
            {termsText}
          </Typography>
        </section>
        <section className={styles.footerButton}>
          <Button
            className={styles.buttonCancel}
            onClick={onClose}
            data-testid='button-cancel'
          >
            {readOnly ? 'Cerrar' : 'Cancelar'}
          </Button>
          {!readOnly && (
            <Button
              className={styles.buttonAccept}
              onClick={onAccept}
              data-testid='button-accept'
            >
              Aceptar
            </Button>
          )}
        </section>
      </Box>
    </Modal>
  );
};
